import moment from "moment";
import { ContentUpdateStatus } from "./ContentUpdateStatus";
import { IStorageUser, ObjectDataset } from "@tblabs/storage";


export class ContentProvider<T extends object>
{
    private content?: T;

    constructor(private _repo: ObjectDataset<T>) 
    { }

    public get IsAuthorized(): boolean
    {
        return this._repo.Database.IsAuthorized;
    }

    public get User(): IStorageUser
    {
        return this._repo.Database.User;
    }

    public get Content(): T
    {
        if (!this.content)
        {
            throw new Error('Content not loaded');
        }

        return this.content;
    }

    private Log(...args: any[])
    {
        // console.log('[ContentProvider]', ...args);
    }

    public async Load(): Promise<void>
    {
        if (this.content)
        {
            this.Log('Content loaded from in-memory cache.');

            return;
        }

        else
        {
            this.Log('Loading content from storage...');

            this.content = await this._repo.GetOne(this._repo.Name);

            if (this.content)
            {
                this.Log('Content loaded from storage.');
            }
            else
            {
                throw new Error(`Could not get content`);
            }
        }
    }

    private async Save(as: string): Promise<ContentUpdateStatus>
    {
        try
        {
            const id = as;
            const size = JSON.stringify(this.Content).length / 1024;

            await this._repo.Update(id, this.Content);

            return ContentUpdateStatus.Success(size, id);
        }
        catch (error: any)
        {
            return ContentUpdateStatus.Error(`Failed to save content: ${error.message}`);
        }
    }

    private async Add(id: string): Promise<ContentUpdateStatus>
    {
        try
        {
            const size = JSON.stringify(this.Content).length / 1024;

            await this._repo.Add(id, this.Content);

            return ContentUpdateStatus.Success(size, id);
        }
        catch (error: any)
        {
            return ContentUpdateStatus.Error(`Failed to save content: ${error.message}`);
        }
    }

    public async SaveChanges(): Promise<ContentUpdateStatus>
    {
        return await this.Save(this._repo.Name);
    }

    public async Backup(): Promise<ContentUpdateStatus>
    {
        const id = this._repo.Name + "___" + moment().format("YYYY_MM_DD__HH_mm_ss");

        return await this.Add(id);
    }
}
